import { apiClient } from '_app'
import { ApiResponse } from 'dtos'
import { InvoicingDto, VehicleEligibleForInvoicingDto, VehicleInvoicingServiceDto, VehicleReadyForInvoicingDto } from 'dtos/invoicing'
import { download, URIQuery } from 'utils'

const baseUrl = (): string => '/api/invoicing'

export const getInvoicing = () => apiClient.get<ApiResponse<InvoicingDto>>(baseUrl()).then(res => res.data)

export const moveToInvoicingServices = (data: VehicleEligibleForInvoicingDto[]) =>
  apiClient.post<ApiResponse<InvoicingDto>>(`${baseUrl()}/vehicles-eligible-for-invoicing`, data).then(res => res.data)

export const saveInvoicingServices = (data: VehicleInvoicingServiceDto[], readyToInvoice: boolean) =>
  apiClient.post<ApiResponse<InvoicingDto>>(`${baseUrl()}/invoicing-services` + URIQuery({ readyToInvoice }), data).then(res => res.data)

export const saveReadyForInvoicing = (data: VehicleReadyForInvoicingDto[], sendToQuickBooks: boolean, invoiced: boolean) =>
  apiClient.post<ApiResponse<InvoicingDto>>(`${baseUrl()}/ready-for-invoicing` + URIQuery({ sendToQuickBooks, invoiced }), data).then(res => res.data)

export const getInvoicingDocuments = (vehicleGuids: string[]) =>
  apiClient.post<string>(`${baseUrl()}/documents`, vehicleGuids).then(res => {
    download(res.data, 'InvoicingDocuments.pdf', 'application/pdf')
  })
